import { Controller } from "@hotwired/stimulus";

// Mounts once per import-summary row, reading each recipient's scheduled/expires/preview-url
// values off the selected <option>'s data attributes, rendered by
// bulk_gift_recipients_preview_options (app/helpers/bulk_management_helper.rb).
//
// This is a plain <select>, not one of the select2 widgets initializers.js.erb binds globally, so
// its "change" is a real DOM event and binds through data-action like any other.
export default class extends Controller {
  static get targets() { return ["select", "scheduledAt", "expiresOn"]; }

  updatePreview() {
    const selected = this.selectTarget.selectedOptions[0];
    this.scheduledAtTarget.textContent = selected.dataset.scheduled;
    this.expiresOnTarget.textContent = selected.dataset.expires;
  }

  openPreview(event) {
    event.preventDefault();
    const selected = this.selectTarget.selectedOptions[0];
    window.open(selected.dataset[event.params.attr], "_blank");
  }
}
